import { Grid, Box, Typography } from "@mui/material";

const VsElement = () => {
    return (
        <Grid item xs={6} sm={12} md={1}>
            <Box display="flex" justifyContent="center" sx={{ pt: { sm: 1, md: 2 } }}>
                <Typography variant="button">
                    VS
                </Typography>
            </Box>
        </Grid>
    );
};

export default VsElement;